import * as actions from "./policyInsightsConflictAckPatchActions";

// Reserved for future per-ack UI feedback (e.g. a row spinner via `loading`,
// "you just acked X" via `lastAckedId`, an inline error chip via `error`).
// The dismiss UX today is driven entirely by the optimistic flow in the
// conflicts-get reducer — nothing reads this slice yet. Note: `loaded`
// intentionally goes back to `false` on failure so a future reader can use
// it as "PATCH finished successfully" rather than "PATCH finished".
const initialState = {
  loading: false,
  loaded: false,
  error: null,
  lastAckedId: null,
};

const ACTION_HANDLERS = {
  [actions.POLICY_INSIGHTS_CONFLICT_ACK_PATCH_REQUEST]: (state, action) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
    lastAckedId: action.id,
  }),
  [actions.POLICY_INSIGHTS_CONFLICT_ACK_PATCH_REQUEST_SUCCESS]: (state) => ({
    ...state,
    loading: false,
    loaded: true,
    error: null,
  }),
  [actions.POLICY_INSIGHTS_CONFLICT_ACK_PATCH_REQUEST_FAILURE]: (
    state,
    action
  ) => ({
    ...state,
    loading: false,
    loaded: false,
    error: action.error,
  }),
};

export default function policyInsightsConflictAckPatchReducer(
  state = initialState,
  action
) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
